import React, { useState } from 'react';
import { LEAD_STATUSES, DEFAULT_STATUSES } from '@/constants/leadStatuses';
import AppDropdown from '@/components/AppDropdown';
import AppInput from '@/components/AppInput';
import AppBox from '@/components/AppBox';
import AppButton from '@/components/AppButton';
import AppIcon from '@/components/AppIcon';
import { FORM_ELEMENT_HEIGHT } from "@/constants/styles";
import clsx from "clsx";

interface StatusSelectProps {
  value: string;
  onChange: (status: string) => void;
  dropdownProps?: {
    position?: "up" | "down" | "auto";
  };
}

const StatusSelect: React.FC<StatusSelectProps> = ({ value, onChange, dropdownProps }) => {
  const [isCustom, setIsCustom] = useState(false);
  const [customStatus, setCustomStatus] = useState('');

  const handleChange = (newValue: string | number) => {
    const stringValue = String(newValue);
    
    if (stringValue === 'custom') {
      setIsCustom(true);
      return;
    }
    onChange(stringValue);
  };

  const handleCustomSubmit = () => {
    if (customStatus.trim()) {
      onChange(customStatus.trim());
      setIsCustom(false);
      setCustomStatus('');
    }
  };

  return (
    <AppBox gap={2} width={200}>
      {!isCustom ? (
        <AppDropdown
          label={value || 'Select Status'}
          value={value}
          onChange={handleChange}
          items={[
            { value: '', label: 'no status' },
            ...DEFAULT_STATUSES.map(status => ({
              value: status,
              label: status
            })),
            { value: 'custom', label: '+ add custom status' }
          ]}
          className={clsx(
            "capitalize",
            FORM_ELEMENT_HEIGHT
          )}
          {...dropdownProps}
        />
      ) : (
        <AppBox gap={2}>
          <AppInput
            value={customStatus}
            onChange={setCustomStatus}
            placeholder="Enter custom status..."
          />
          <button
            className="text-primary hover:text-green-700"
            onClick={handleCustomSubmit}
          >
            <AppIcon name="check" />
          </button>
          {/* Cancel Icon */}
          <button
            className="text-error hover:text-error-hover"
            onClick={() => setIsCustom(false)}
          >
            <AppIcon name="x" />
          </button>
        </AppBox>
      )}
    </AppBox>
  );
};

export default StatusSelect; 